import { RUB } from '../../../utils/char';
import { useTranslation } from '../../../utils/useTranslation';
import { Box } from '../../layout/Box';
import { themeColorMap } from './constants';
import { BadgeContainer, CurrencyIcon, BadgeLabel } from './styles';
import { ProductMonetizationProps } from './types';

export const ProductMonetization: React.FC<ProductMonetizationProps> = ({ color, ...props }) => {
    const t = useTranslation();

    const themeColor = themeColorMap[color];

    return (
        <Box {...props}>
            <BadgeContainer backgroundColor={themeColor.backgroundColor}>
                <CurrencyIcon backgroundColor={themeColor.color} color={themeColor.backgroundColor}>
                    {RUB}
                </CurrencyIcon>
                <BadgeLabel color={themeColor.color}>{t('Есть монетизация')}</BadgeLabel>
            </BadgeContainer>
        </Box>
    );
};
